module.exports = __webpack_public_path__ + "static/media/logo-grey.6a898fac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dublin-express/logo-grey.svg
// module id = 290
// module chunks = 0